// extracted by mini-css-extract-plugin
export default {"products":"Products_products__Jm5Xe","filters":"Products_filters__t4EPK","showPage":"Products_showPage__sokMu","fDiv":"Products_fDiv__BWpfd"};